// extracted by mini-css-extract-plugin
var _1 = "ReactionThreadDesktop-module__animatedBackground--JeIZD";
var _2 = "ReactionThreadDesktop-module__compact--fqjE7";
var _3 = "ReactionThreadDesktop-module__container--ixl61";
var _4 = "ReactionThreadDesktop-module__expanded--dtXon";
var _5 = "ReactionThreadDesktop-module__hasMoreThanOneReactions--HDq5S";
var _6 = "ReactionThreadDesktop-module__innerContainer--RIBCS";
var _7 = "5px";
export { _1 as "animatedBackground", _2 as "compact", _3 as "container", _4 as "expanded", _5 as "hasMoreThanOneReactions", _6 as "innerContainer", _7 as "overlap" }
